import {environment} from '../../../../environments/environment';

export enum LAYERS_ID {
    WAZE_LAYER = 'waze',
    WAZE_LINE_LAYER = 'waze_line',
    WAZE_POIS_LAYER = 'waze_pois',
    WAZE_POIS_ICONS_LAYER = 'waze_pois_icons',

};

export const LAYERS_SQL = {};

LAYERS_SQL[LAYERS_ID.WAZE_LINE_LAYER] = `
    select
      cartodb_id,
      the_geom,
      the_geom_webmercator,
      'JAM' as layer,
      'JAM' as type,
      level,
      street,
      length as roadlength,
      speed,
      delay,
      'waze' as source
    from ${environment.city}_waze_data_jams_mv
    where georss_date is not null
  `;
LAYERS_SQL[LAYERS_ID.WAZE_POIS_LAYER] = `
  SELECT
  ROW_NUMBER() OVER() as cartodb_id, the_geom, the_geom_webmercator, source,
  layer, type, level, street, roadlength, speed, delay, time_start, time_finish,
  description, subtype, type_level
  FROM (
    (SELECT ST_PointOnSurface(the_geom) AS the_geom,
      ST_PointOnSurface(the_geom_webmercator) as the_geom_webmercator, 'waze' as source,
      'JAM' as layer, 'JAM' as type, level, street, length as roadlength, speed, delay,
      NULL::timestamp as time_start, NULL::timestamp as time_finish, NULL as description, NULL::text as subtype,
      NULL as type_level
    FROM ${environment.city}_waze_data_jams_mv
    WHERE georss_date is not null)
    UNION ALL
    SELECT the_geom, the_geom_webmercator, 'waze' as source,
      'ALERTS' as layer, CASE
        WHEN subtype = 'HAZARD_ON_ROAD_CONSTRUCTION' THEN 'CONSTRUCTION'
        WHEN type = 'ACCIDENT' THEN 'ACCIDENT'
        WHEN type = 'WEATHERHAZARD' THEN 'WEATHERHAZARD'
      END as type, NULL::integer as level, street, NULL::integer as roadlength,
      NULL::double precision as speed, NULL::double precision as delay,
      date as time_start, NULL::timestamp as time_finish,
      NULL::text as description, subtype,
      CASE
        WHEN subtype = 'HAZARD_ON_ROAD_CONSTRUCTION' then 'CONSTRUCTION-medium'
        ELSE type_level END
        as type_level
    FROM ${environment.city}_waze_data_alerts_mv
    WHERE type NOT IN ('ROAD_CLOSED', 'JAM')
  ) _q
  `;



// WEBPACK FOOTER //
// ./src/app/real-time/real-time/layers/constants.ts